import React from 'react';
import { Users, UserPlus, MoreVertical, Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function PatientsList() {
    const navigate = useNavigate();

    // Sample data derived from the fields in the PDF [cite: 3, 6, 7]
    const patients = [
        { id: "P-001", name: "Sunil Perera", nic: "198512345678", phone: "0771234567", address: "Colombo 07" },
    ];

    return (
        <div className="animate-in fade-in duration-500">
            <div className="flex justify-between items-end mb-10">
                <div>
                    <h1 className="text-4xl font-extrabold text-slate-800 tracking-tight">Patients Directory</h1>
                    <p className="text-slate-500 font-medium mt-1">Manage clinical and astrological records[cite: 9, 10].</p>
                </div>
                <button
                    onClick={() => navigate('/store/new-patient')}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white flex items-center gap-2 px-6 py-3 rounded-2xl shadow-lg transition-all font-bold"
                >
                    <UserPlus size={20} /> Register New Patient
                </button>
            </div>

            <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 overflow-hidden">
                <div className="p-8 border-b border-slate-50 flex items-center justify-between bg-slate-50/30">
                    <div className="flex items-center gap-3">
                        <Users size={20} className="text-emerald-500" />
                        <h2 className="font-bold text-slate-800">Recent Registrations</h2>
                    </div>
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead>
                        <tr className="text-slate-400 text-[10px] uppercase tracking-widest border-b border-slate-50 font-black">
                            <th className="px-8 py-5">NIC Number [cite: 3]</th>
                            <th className="px-8 py-5">Patient Name</th>
                            <th className="px-8 py-5">Address [cite: 6]</th>
                            <th className="px-8 py-5">Phone [cite: 7]</th>
                            <th className="px-8 py-5 text-right">Action</th>
                        </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-50">
                        {patients.map((p, index) => (
                            <tr key={index} className="group hover:bg-slate-50/50 transition-all">
                                <td className="px-8 py-5 font-mono text-sm text-slate-400">{p.nic}</td>
                                <td className="px-8 py-5 font-bold text-slate-800">{p.name}</td>
                                <td className="px-8 py-5 text-slate-500 text-sm">{p.address}</td>
                                <td className="px-8 py-5 text-slate-700 font-medium">{p.phone}</td>
                                <td className="px-8 py-5 text-right">
                                    <button className="p-2 hover:bg-white rounded-xl border border-transparent hover:border-slate-100 transition-all">
                                        <MoreVertical size={18} className="text-slate-300" />
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}